import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import couterpart from 'counterpart';
import DatePicker from 'react-datepicker';
import { ToastsContainer, ToastsStore } from 'react-toasts';
import Spinner from 'react-spinner-material';

import { FaFilter } from 'react-icons/fa';
import { MdImportExport } from 'react-icons/md';
import Dialog from 'react-bootstrap-dialog';
import { Multiselect } from 'multiselect-react-dropdown';

import "react-table/react-table.css";
import "../css/style.css";

import { DATA_TYPE_PRODUCT, PORT_IN_USED } from '../constants';
import MenuComponent2 from './MenuComponent2';
import QualityProductListView from './QualityProductListView';
import WorkOrderUtil from '../utilities/WorkOrderUtil';
import WorkOrderDataService from '../services/WorkOrderDataService';
import MasterDataService from '../services/MasterDataService';
import AuthenticationService from '../services/AuthenticationService';
import UserDataService from '../services/UserDataService';
import ItemDataService from '../services/ItemDataService';
import ShopDataService from '../services/ShopDataService';
import WorkOrderAdditions from './WorkOrderAdditions';

import { ICON_COLOR } from '../icon';
import queryString from 'query-string'

import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import { ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary } from '@material-ui/core';
import ItemDetailsViewById from './ItemDetailsViewById';
import WorkOrderImages from './WorkOrderImages';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import { TiRefresh } from 'react-icons/ti';


class QualityProductList extends Component {
  constructor() {
    super();

    const numOfMonths = 24;
    var fromDate = new Date(new Date().getTime() - numOfMonths * 30 * 24 * 60 * 60 * 1000 * 3);//1 month
    fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);
    var toDate = new Date();
    toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(toDate);

    this.state = {
      countries: [],
      spinnerVisible: false,
      allStatus: [],
      fromDate: fromDate,
      toDate: toDate,
      fromDeadlineDate: toDate,
      toDeadlineDate: toDate,
      status: '0',
      country: '',
      customer: null,
      orderNo: null,
      woStatus: 0,
      workOrders: [],
      includeImage: 0,
      childRefreshCount: 0,
      selectAll: 0,
      show: false,
      deadline: '0',
      selectedWoStatusList: [],
      items: [],
      sku: '',
      csReview: '4',
      shops: [],
      personalization: '',
      filterItemType: 3,
      workerId: 0,
      selectedWorkerName: '',
      urgent: 0,
      workOrder: {}
    };
  }

  loadItems() {
    ItemDataService.retrieveItems().then(data => {
      // console.log('ITEMS', data)
      this.setState({
        items: data
      });
    });
  }

  loadShops() {
    ShopDataService.retrieveCachedShops().then(data => {
      if (data.message === undefined) {
        this.setState({ shops: data });
      } else {
        this.setState({ shops: [] });
      }
    });
  }

  loadDesigners() {
    if (AuthenticationService.isAdmin() || AuthenticationService.isService()) {
      UserDataService.retrieveDesigners().then(data => {
        var len = data.length;
        var designers = [];
        for (var i = 0; i < len; i++) {
          designers.push({ key: data[i].id, label: data[i].firstName + data[i].lastName, value: data[i].id, userName: data[i].userName })
        }
        this.setState({ designers: designers });
      });
    }
  }

  loadCountries() {
    MasterDataService.retrieveCountryMappings().then(data => {
      if (data !== undefined && data !== null && data instanceof Array) {
        let countries = [];
        for (let i = 0; i < data.length; i++) {
          let code = data[i].code;
          countries.push({
            id: code,
            name: code
          });
        }
        this.setState({ countries: countries })
      }
    });
  }

  componentDidMount() {
    let vm = this;
    MasterDataService.retrieveAllStatus().then(data => {
      let statusList = [];

      if (data !== undefined && data !== null) {
        statusList.push({
          id: 0,
          name: 'All'
        });
        for (let i = 0; i < data.length; i++) {
          if (data[i].type !== 2) {
            continue;
          }

          statusList.push({
            id: data[i].status,
            name: data[i].statusDescVn
          });
        }
      }

      this.setState({ allStatus: data, statusList: statusList })
    });

    let deadline = vm.getItem("qualityprod.deadline");
    if (deadline === undefined || deadline === null) {
      deadline = '0';
    }

    this.loadDesigners();
    this.loadItems();
    this.loadCountries();
    this.loadShops();
    this.loadWorkers();

    let fromDate = this.getItem("qualityprod.fromDate")
    let toDate = this.getItem("qualityprod.toDate")

    const values = queryString.parse(this.props.location.search);
    let numOfMonths = 1;
    if (values !== undefined && values.status !== undefined) {
      numOfMonths = 24;
    }

    let swoStatusList = WorkOrderUtil.getItem('qualityprod.selectedWoStatusList');
    let woStatusList = [];
    try {
      woStatusList = JSON.parse(swoStatusList)
    } catch (ec) {

    }

    if (values === undefined || (values.status === undefined && values.isback === undefined) || fromDate === null || fromDate === undefined) {
      let backTime = 12 * 30 * 24 * 60 * 60 * 1000 * numOfMonths;
      fromDate = new Date(new Date().getTime() - backTime);//12 month
      fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);
    }

    if (toDate === null || toDate === undefined) {
      toDate = new Date();
      toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(toDate);
    }

    let semi = WorkOrderUtil.getItem("qualityprod.semi");
    let ignoreSemi = '1';

    if (semi == 0 || semi == 1) {
      ignoreSemi = '-1';
    }

    let status = vm.getItem("qualityprod.status");
    let sku = vm.getItem("qualityprod.sku");
    let csReview = vm.getItem("qualityprod.csReview");
    let incident = vm.getItem("qualityprod.incident");
    let store = vm.getItem("qualityprod.store");
    let personalization = vm.getItem("qualityprod.personalization");
    let includeMau = vm.getItem("qualityprod.includeMau");
    let filterItemType = vm.getItem("qualityprod.filterItemType");
    if (filterItemType === undefined || filterItemType === null) {
      filterItemType = '3';
    }

    let urgent = WorkOrderUtil.getItem("qualityprod.urgent");
    if (!urgent) {
      urgent = 0;
    }

    this.setState({
      fromDate: fromDate,
      toDate: toDate,
      status: status,
      country: vm.getItem("qualityprod.country"),
      customer: vm.getItem("qualityprod.customer"),
      orderNo: vm.getItem("qualityprod.orderNo"),
      pcode: vm.getItem("qualityprod.pcode"),
      // woStatus: vm.getItem("qualityprod.woStatus"),
      selectedWoStatusList: woStatusList,
      deadline: deadline,
      semi: semi,
      ignoreSemi: ignoreSemi,
      sku: sku,
      csReview: csReview,
      incident: incident,
      store: store,
      personalization: personalization,
      includeMau: includeMau,
      filterItemType: filterItemType,
      urgent: urgent
    }, () => {
      const query = queryString.parse(this.props.location.search);
      if (query.caller !== '0') { //Clicked on NAV
        this.filterWorkOrdersBy();
      }
    });

  }

  toggleRow(id) {
    const newSelected = Object.assign({}, this.state.selected);
    newSelected[id] = !this.state.selected[id];
    this.setState({
      selected: newSelected,
      selectAll: 2
    });
  }

  getItem(key) {
    let value = sessionStorage.getItem(key);
    return value === null || value === '' || value === 'null' ? undefined : value
  }
  saveItem(key, value) {
    if (value !== undefined && value !== 'null' && value !== '') {
      sessionStorage.setItem(key, value);
    }
  }
  clearSearchInfo() {
    sessionStorage.removeItem("qualityprod.fromDate")
    sessionStorage.removeItem("qualityprod.toDate")
    sessionStorage.removeItem("qualityprod.status")
    sessionStorage.removeItem("qualityprod.country")
    sessionStorage.removeItem("qualityprod.customer")
    sessionStorage.removeItem("qualityprod.orderNo")
    sessionStorage.removeItem("qualityprod.pcode")
    sessionStorage.removeItem("qualityprod.woStatus")
    sessionStorage.removeItem("qualityprod.deadline")
    sessionStorage.removeItem("qualityprod.selectedWoStatusList");
    sessionStorage.removeItem("qualityprod.semi");
    sessionStorage.removeItem("qualityprod.sku");
    sessionStorage.removeItem("qualityprod.includeImage");
    sessionStorage.removeItem("qualityprod.csReview");
    sessionStorage.removeItem("qualityprod.incident");
    sessionStorage.removeItem("qualityprod.store");
    sessionStorage.removeItem("qualityprod.personalization");
    sessionStorage.removeItem("qualityprod.includeMau");
    sessionStorage.removeItem("qualityprod.filterItemType");
    sessionStorage.removeItem("qualityprod.urgent");
  }
  saveSearchInfo(fromDate, toDate, status, country, customer, orderNo, woStatus, pcode, deadline, selectedWoStatusList, semi, sku, includeImage, csReview, incident, store, personalization, includeMau, filterItemType, urgent) {
    sessionStorage.setItem("qualityprod.fromDate", fromDate);
    sessionStorage.setItem("qualityprod.toDate", toDate);
    this.saveItem("qualityprod.status", status);
    this.saveItem("qualityprod.country", country);
    this.saveItem("qualityprod.customer", customer);
    this.saveItem("qualityprod.orderNo", orderNo);
    this.saveItem("qualityprod.pcode", pcode);
    this.saveItem("qualityprod.woStatus", woStatus);
    this.saveItem("qualityprod.deadline", deadline);
    this.saveItem("qualityprod.selectedWoStatusList", JSON.stringify(selectedWoStatusList));
    this.saveItem("qualityprod.semi", semi);
    this.saveItem("qualityprod.sku", sku);
    this.saveItem("qualityprod.includeImage", includeImage);
    this.saveItem("qualityprod.csReview", csReview);
    this.saveItem("qualityprod.incident", incident);
    this.saveItem("qualityprod.store", store);
    this.saveItem("qualityprod.personalization", personalization);
    this.saveItem("qualityprod.includeMau", includeMau);
    this.saveItem("qualityprod.filterItemType", filterItemType);
    this.saveItem("qualityprod.urgent", urgent);
  }

  onFilter() {
    this.clearSearchInfo();
    this.filterWorkOrdersBy();
  }

  filterWorkOrdersBy() {
    var fromDate = this.state.fromDate;
    var toDate = this.state.toDate;
    let byDeadline = this.state.byDeadline;
    let fromDeadlineDate = this.state.fromDeadlineDate;
    let toDeadlineDate = this.state.toDeadlineDate;
    var status = this.state.status;
    var woStatus = this.state.woStatus;
    var country = this.state.country;
    var customer = this.state.customer;
    var orderNo = this.state.orderNo;
    var pcode = this.state.pcode;
    let c = this.state.childRefreshCount + 1
    let deadline = this.state.deadline;
    let selectedWoStatusList = this.state.selectedWoStatusList ? this.state.selectedWoStatusList : []

    let semi = this.state.semi ? this.state.semi : -1;
    let ignoreSemi = this.state.ignoreSemi;
    let sku = this.state.sku;
    let includeImage = this.state.includeImage;
    let csReview = this.state.csReview;
    let incident = this.state.incident;
    let store = this.state.store;
    let personalization = this.state.personalization;
    let includeMau = this.state.includeMau;
    let filterItemType = this.state.filterItemType;
    let workerId = this.state.workerId;
    let urgent = this.state.urgent ? this.state.urgent : 0;

    try {
      let selectedWoStatusCodes = [];
      if (selectedWoStatusList) {
        for (let i = 0; i < selectedWoStatusList.length; i++) {
          selectedWoStatusCodes.push(selectedWoStatusList[i].id);
        }
      }

      let info = {
        fromDate: fromDate,
        toDate: toDate,
        status: status,
        orderNo: orderNo,
        // woStatus: woStatus,
        woStatusList: selectedWoStatusCodes,
        pcode: pcode,
        country: country,
        customer: customer,
        deadline: deadline,
        byDeadline: byDeadline,
        fromDeadlineDate: fromDeadlineDate,
        toDeadlineDate: toDeadlineDate,
        sortBy: 'orderDate',
        semi: semi,
        ignoreSemi: ignoreSemi,
        sku: sku,
        includeImage: includeImage,
        csReview: csReview,
        incident: incident,
        store: store,
        personalization: personalization,
        includeMau: includeMau,
        filterItemType: filterItemType,
        workerId: workerId,
        urgent: urgent
      };

      this.setState({ spinnerVisible: true }, () => {
        this.setState({ workOrders: [] }, () => {
          WorkOrderDataService.searchWorkOrdersBy(info)
            .then(data => {
              this.sleep(100).then(() => { this.setState({ spinnerVisible: false }); });
              if (data.message === undefined) {
                // console.log('[retrieveWorkOrdersBy]', data);
                if (data === undefined || data === null || data === "") {
                  console.log('Invalid returned data. Maybe the number of found work orders is too big');
                  this.setState({ workOrders: [], childRefreshCount: c });
                } else {
                  this.setState({ workOrders: data, childRefreshCount: c });
                }
                this.saveSearchInfo(fromDate, toDate, status, country, customer, orderNo, woStatus, pcode, deadline, selectedWoStatusList, semi, sku, includeImage, csReview, incident, store, personalization, includeMau, filterItemType, urgent);
              } else {
                this.setState({ workOrders: [], childRefreshCount: c });
                ToastsStore.error(data.message);
              }
            });
        });
      });
    } catch (e) {
      this.sleep(100).then(() => { this.setState({ spinnerVisible: false }); });
    }
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  checkSelectedItems() {
    if ((this.state.selectedWorkOrders === undefined) || (this.state.selectedWorkOrders === null || this.state.selectedWorkOrders.length < 1)) {
      return 1
    }
    return 0;
  }

  markWoReviewed() {
    if (PORT_IN_USED == '443') {
      this.exportExportForProduction()
      return;
    }
    this.exportExportForProduction1()
  }

  exportExportForProduction1() {
    if ((this.checkSelectedItems() === 1)) {
      alert(couterpart.translate('error_selected_items_empty'));
      return;
    }

    this.dialog.show({
      title: couterpart.translate("msg_title_confirm"),
      body: couterpart.translate("msg_review_wo_confirm"),
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          try {
            this.setState({ spinnerVisible: true }, () => {
              let selectedItems = [];
              if ((this.state.selectedWorkOrders !== undefined) && (this.state.selectedWorkOrders !== null)) {
                for (let key in this.state.selectedWorkOrders) {
                  if (this.state.selectedWorkOrders[key] === true) {
                    selectedItems.push(parseInt(key));
                  }
                }
              }
              // console.log("[selectedItems]: ", selectedItems);
              // WorkOrderDataService.exportProduction(selectedItems).then(data =>{
              WorkOrderDataService.changeWorkOrderStatus({
                ids: selectedItems,
                status: 56 //Reviewed by admin
              }).then(data => {
                this.setState({ childRefreshCount: this.state.childRefreshCount + 1 }, () => {
                  this.filterWorkOrdersBy();
                  this.sleep(100).then(() => { this.setState({ spinnerVisible: false }); });
                })
              });
            });
          } catch (e) {
            this.sleep(100).then(() => { this.setState({ spinnerVisible: false }); });
          }
        })
      ],
      bsSize: 'small',
      onHide: (dialog) => {
        dialog.hide()
        console.log('closed by clicking background.')
      }
    });
  }

  exportExportForProduction() {
    if ((this.checkSelectedItems() === 1)) {
      alert(couterpart.translate('error_selected_items_empty'));
      return;
    }

    this.dialog.show({
      title: couterpart.translate("msg_title_confirm"),
      body: couterpart.translate("msg_change_wo_confirm"),
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          try {
            this.setState({ spinnerVisible: true }, () => {
              let selectedItems = [];
              if ((this.state.selectedWorkOrders !== undefined) && (this.state.selectedWorkOrders !== null)) {
                for (let key in this.state.selectedWorkOrders) {
                  if (this.state.selectedWorkOrders[key] === true) {
                    selectedItems.push(parseInt(key));
                  }
                }
              }
              // console.log("[selectedItems]: ", selectedItems);
              WorkOrderDataService.exportProduction(selectedItems).then(data => {
                // WorkOrderDataService.changeWorkOrderStatus({
                //     ids: selectedItems,
                //     status: 56 //Reviewed by admin
                //   }).then(data =>{
                this.setState({ childRefreshCount: this.state.childRefreshCount + 1 }, () => {
                  this.filterWorkOrdersBy();
                  this.sleep(100).then(() => { this.setState({ spinnerVisible: false }); });
                })
              });
            });
          } catch (e) {
            this.sleep(100).then(() => { this.setState({ spinnerVisible: false }); });
          }
        })
      ],
      bsSize: 'small',
      onHide: (dialog) => {
        dialog.hide()
        console.log('closed by clicking background.')
      }
    });
  }

  resolveIncidents() {
    if ((this.checkSelectedItems() === 1)) {
      alert(couterpart.translate('error_selected_items_empty'));
      return;
    }

    this.dialog.show({
      title: couterpart.translate("msg_title_confirm"),
      body: couterpart.translate("msg_resolve_incident_confirm"),
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          try {
            this.setState({ spinnerVisible: true }, () => {
              let selectedItems = [];
              if ((this.state.selectedWorkOrders !== undefined) && (this.state.selectedWorkOrders !== null)) {
                for (let key in this.state.selectedWorkOrders) {
                  if (this.state.selectedWorkOrders[key] === true) {
                    selectedItems.push(parseInt(key));
                  }
                }
              }

              WorkOrderDataService.resolveIncidents(selectedItems).then(data => {
                this.setState({ childRefreshCount: this.state.childRefreshCount + 1 }, () => {
                  this.sleep(100).then(() => {
                    this.setState(
                      {
                        spinnerVisible: false
                      });
                  });
                  this.filterWorkOrdersBy();
                });
              });
            });
          } catch (e) {
            this.sleep(100).then(() => {
              this.setState({
                spinnerVisible: false
              });
            });
          }
        })
      ],
      bsSize: 'small',
      onHide: (dialog) => {
        dialog.hide()
        console.log('closed by clicking background.')
      }
    });
  }

  getSelectedItems() {
    let selectedItems = [];
    if ((this.state.selectedWorkOrders !== undefined) && (this.state.selectedWorkOrders !== null)) {
      for (let key in this.state.selectedWorkOrders) {
        if (this.state.selectedWorkOrders[key] === true) {
          selectedItems.push(parseInt(key));
        }
      }
    }
    return selectedItems;
  }

  getSelectedItemsO() {
    let selectedItems = [];
    if ((this.state.selectedWorkOrders !== undefined) && (this.state.selectedWorkOrders !== null)) {
      for (let key in this.state.selectedWorkOrders) {
        if (this.state.selectedWorkOrders[key] === true) {
          console.log('this.state.selectedWorkOrders[key]', this.state.selectedWorkOrders[key]);
          selectedItems.push(this.state.selectedWorkOrders[key]);
        }
      }
    }
    return selectedItems;
  }

  getStatusDescription(status) {
    if (this.state.allStatus === undefined || this.state.allStatus === null) {
      return status;
    }
    let istatus = parseInt(status);
    let statusInfo = this.state.allStatus.find(x => {
      return x.status === istatus;
    });
    if (statusInfo !== undefined) {
      return statusInfo.statusDescVn;
    }
    return status;
  }

  handleFromDateChange(date) {
    var sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({
      fromDate: sDate
    });
  }

  handleByDeadlineClick() {
    if (this.state.byDeadline === '1') {
      this.setState({ byDeadline: '0' });
    } else {
      this.setState({ byDeadline: '1' });
    }
  }

  handleIncludeImageClick() {
    if (this.state.includeImage === 1) {
      this.setState({ includeImage: 0 });
    } else {
      this.setState({ includeImage: 1 }, () => {
        this.filterWorkOrdersBy();
      });
    }
  }

  handleIncludeMauClick() {
    if (this.state.includeMau === 1) {
      this.setState({ includeMau: 0 }, () => {
        this.filterWorkOrdersBy();
      });
    } else {
      this.setState({ includeMau: 1 }, () => {
        this.filterWorkOrdersBy();
      });
    }
  }

  handleUrgentClick() {
    if (this.state.urgent == 1) {
      this.setState({ urgent: 0 }, () => {
        this.filterWorkOrdersBy();
      });
    } else {
      this.setState({ urgent: 1 }, () => {
        this.filterWorkOrdersBy();
      });
    }
  }

  handleIncidentClick() {
    if (this.state.incident === 'Y') {
      this.setState({ incident: 'N' });
    } else {
      this.setState({ incident: 'Y' }, () => {
        this.filterWorkOrdersBy();
      });
    }
  }

  handleToDateChange(date) {
    var sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({
      toDate: sDate
    });
  }

  handleFromDeadlineDateChange(date) {
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({
      fromDeadlineDate: sDate
    });
  }

  handleToDeadlineDateChange(date) {
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({
      toDeadlineDate: sDate
    });
  }
  handleStatusChange(e) {
    var value = e.target[e.target.selectedIndex].value;
    this.setState({
      status: value
    });
  }

  handleWoStatusChange(e) {
    var value = e.target[e.target.selectedIndex].value;
    this.setState({
      woStatus: value
    });
  }

  handleWoChangeStatusChange(e) {
    var value = e.target[e.target.selectedIndex].value;
    this.setState({
      woChangedStatus: value
    });
  }

  handleCountryChange(e) {
    var value = e.target[e.target.selectedIndex].value;
    sessionStorage.setItem("qualityprod.country", value)
    this.setState({
      country: value
    });
  }

  handleCustomerChange(e) {
    var value = e.target.value;
    this.setState({
      customer: value
    });
  }

  handleOrderNoChange(e) {
    var value = e.target.value;
    this.setState({
      orderNo: value
    });
  }

  handlePcodeChange(e) {
    var value = e.target.value;
    this.setState({
      pcode: value
    });
  }

  renderStatusList() {
    if (this.state.allStatus === undefined || this.state.allStatus === null) {
      return (<></>);
    }
    return (
      <select onChange={this.handleStatusChange.bind(this)}
        value={this.state.status}>
        <option value="all">{couterpart.translate('workorder_status_all')}</option>
        {this.state.allStatus.filter(y => {
          return y.type === 1;
        }).map(x => <option value={x.status} key={x.status}>{x.statusDescVn}</option>)}
      </select>
    );
  }

  renderWoStatusList() {
    if (this.state.allStatus === undefined || this.state.allStatus === null) {
      return (<></>);
    }

    return (
      <select onChange={this.handleWoStatusChange.bind(this)} style={{ padding: '5px' }}
        value={this.state.woStatus}>
        <option value="all">{couterpart.translate('order_status_all')}</option>
        {this.state.allStatus.filter(y => {
          return y.type === 2;
        }).map(x => <option value={x.status} key={x.status}>{x.statusDescVn}</option>)}
      </select>
    );
  }

  renderWoChangeStatusList() {
    if (this.state.allStatus === undefined || this.state.allStatus === null) {
      return (<></>);
    }

    return (
      <select onChange={this.handleWoChangeStatusChange.bind(this)} className="selectBox2"
        value={this.state.woStatus}>
        <option value="all">{couterpart.translate('order_status_all')}</option>
        {this.state.allStatus.filter(y => {
          return y.type === 2;
        }).map(x => <option value={x.status} key={x.status}>{x.statusDescVn}</option>)}
      </select>
    );
  }

  renderTypeList() {
    if (this.state.shapeDesigns === undefined || this.state.shapeDesigns === null || this.state.shapeDesigns.length < 1) {
      return (<></>);
    }
    return (
      <div>
        <input type="text" name="shapeDesign" size="5" className="inputBox"
          list="shapeDesigns"
          defaultValue={this.state.workOrder.shapeDesign}
          onChange={this.handleTypeChange.bind(this)} />
        <datalist id="shapeDesigns">
          {this.state.shapeDesigns.map(x => <option value={x.name} key={x.name}>{x.name}</option>)}
        </datalist>
      </div>
    );
  }

  renderColorList() {
    if (this.state.colors === undefined || this.state.colors === null || this.state.colors.length < 1) {
      return (<></>);
    }
    return (
      <div>
        <input type="text" name="colorMaterial" size="5" className="inputBox"
          list="colors"
          defaultValue={this.state.workOrder.colorMaterial}
          onChange={this.handleColorMaterialChange.bind(this)} />
        <datalist id="colors">
          {this.state.colors.map(x => <option value={x.nameVn} key={x.nameVn}>{x.nameVn}</option>)}
        </datalist>
      </div>
    );
  }

  renderFontList() {
    if (this.state.fonts === undefined || this.state.fonts === null || this.state.fonts.length < 1) {
      return (<></>);
    }
    return (
      <div>
        <input type="text" name="font" size="5" className="inputBox"
          list="fonts"
          defaultValue={this.state.workOrder.font}
          onChange={this.handleFontChange.bind(this)} />
        <datalist id="fonts">
          {this.state.fonts.map(x => <option value={x.name} key={x.name}>{x.name}</option>)}
        </datalist>
      </div>
    );
  }

  showDetails(workOrdrId) {
    WorkOrderDataService.retrieveById(workOrdrId).then(data => {
      this.setState({
        show: true,
        workOrder: data
      });
    });
  }

  renderProductList() {
    return (<QualityProductListView workOrders={this.state.workOrders}
      refreshCount={this.state.childRefreshCount} includeImage={this.state.includeImage}
      reloadCallback={this.filterWorkOrdersBy.bind(this)}
      showDetails={this.showDetails.bind(this)}
      taoSuCoCallback={this.gotoReport.bind(this)} />);
  }

  handleSetStatusChange(e) {
    var value = e.target[e.target.selectedIndex].value;
    this.setState(prevState => ({
      newStatus: value
    }));
  }

  handleWorkOrderNoteChange(e) {
    var newValue = e.target.value;
    this.setState(prevState => ({
      workOrderNote: newValue
    }));
  }

  renderDesignerOption(option) {
    return (
      <option key={option.key} value={option.userName}>{option.userName}</option>
    );
  }

  handleSelectChange(e) {
    var value = e.target[e.target.selectedIndex].value;
    this.setState({
      selectedDesigner: value
    });
  };

  renderDesigners() {
    if ((this.state.designers === undefined) || (this.state.selectOptions === null)) {
      return (<></>);
    }
    return (
      <select onChange={this.handleSelectChange.bind(this)} style={{ padding: '1px', marginTop: '5px' }}>
        <option key="" value=""></option>
        {this.state.designers !== undefined && this.state.designers.map(option => this.renderDesignerOption(option))}
      </select>
    );
    //button_mark_reviewed
  }

  renderSelectedItem(item) {
    if (this.state.workOrders === undefined || this.state.workOrders === null || !(this.state.workOrders instanceof Array)) {
      return (<></>);
    }

    let wo = this.state.workOrders.find(it => {
      return it.id === item
    });

    if (wo === undefined) {
      return (<></>);
    }

    return (
      <div className="row" key={'row_' + item}>
        <div className="col-4 border-left border-top border-bottom border-right border-light-gray" key={'col_' + item + '_1'}>{wo.workOrderNo} </div>
        <div className="col-3 border-left border-top border-bottom border-right border-light-gray" key={'col_' + item + '_2'}>{wo.fullPCode} </div>
        <div className="col-3 border-left border-top border-bottom border-right border-light-gray" key={'col_' + item + '_3'}>{wo.customer} </div>

      </div>
    );
  }

  renderSelectedList() {
    let selectedItems = this.getSelectedItems();
    return (
      <>
        {selectedItems.map(it => this.renderSelectedItem(it))}
      </>
    )
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleCombine() {

  }

  handleDeadlineClick(e) {
    let value = e.target.value;
    this.setState({ deadline: value });
  }

  handleCSReviewClick(e) {
    let value = e.target.value;
    this.setState({ csReview: value });
  }

  handleSkuChange(e) {
    var value = e.target.value;
    this.setState(prevState => ({
      sku: value
    }));
  }

  handlePersonalizationChange(e) {
    var value = e.target.value;
    this.setState(prevState => ({
      personalization: value
    }));
  }

  renderItemList() {
    if (this.state.items === undefined || this.state.items === null) {
      return (<></>);
    }
    let options = this.state.items !== undefined ? this.state.items : []
    console.log(options);

    return (
      <div style={{ paddingLeft: '0px', paddingRight: '0px' }}>
        <input type="text" name="font" size="16" className="selectBox3"
          list="skus"
          placeholder={couterpart.translate('work_order_code')}
          defaultValue={this.state.sku}
          onChange={this.handleSkuChange.bind(this)} onKeyDown={(e) => { e.persist(); setTimeout(() => { this.handleSkuChange(e) }, 0); }} />
        <datalist id="skus">
          {options.map(x => <option value={x.sku} key={x.sku}>{x.sku}</option>)}
        </datalist>
      </div>
    );
  }

  renderPersonalization() {
    return (
      <div style={{ paddingLeft: '0px', paddingRight: '0px' }}>
        <input type="text" name="font" size="16" className="textB"
          placeholder={couterpart.translate('work_order_personalization')}
          defaultValue={this.state.personalization}
          onChange={this.handlePersonalizationChange.bind(this)} onKeyDown={(e) => { e.persist(); setTimeout(() => { this.handlePersonalizationChange(e) }, 0); }} />
      </div>
    );
  }

  renderSemi() {
    return (
      <>
        <div style={{ marginLeft: "1px" }}>
          <div>
            <label><input type="checkbox" value="1" onChange={this.handleSemiClick.bind(this)} checked={this.state.semi == 1 ? true : false} /> {couterpart.translate('wo_semi')} </label>
          </div>
        </div>
        <div style={{ marginLeft: "1px" }}>
          <div>
            <label><input type="checkbox" value="1" onChange={this.handleIgnoreSemiClick.bind(this)} checked={this.state.ignoreSemi == 1 ? true : false} /> {couterpart.translate('wo_ignore_semi')} </label>
          </div>
        </div>
      </>
    );
  }

  renderItemTypeFilter() {
    return (
      <>
        <div style={{ marginLeft: "1px" }}>
          <div>
            <label><input type="radio" value="1" onChange={this.handleItemTypeClick.bind(this)} checked={this.state.filterItemType == 1 ? true : false} /> {couterpart.translate('wo_len_da')} </label>&nbsp;&nbsp;
            <label><input type="radio" value="2" onChange={this.handleItemTypeClick.bind(this)} checked={this.state.filterItemType == 2 ? true : false} /> {couterpart.translate('wo_normal')} </label>
            <label><input type="radio" value="3" onChange={this.handleItemTypeClick.bind(this)} checked={this.state.filterItemType == 3 ? true : false} /> {couterpart.translate('wo_all')} </label>
          </div>
        </div>
      </>
    );
  }

  renderDealine() {
    return (
      <>
        <div style={{ marginLeft: "1px" }}>
          <div>
            <input type="radio" value="1" checked={this.state.deadline === '1' ? true : false} onChange={this.handleDeadlineClick.bind(this)} /> <label> {couterpart.translate('wo_deadline')} </label>
          </div>
        </div>
        <div style={{ marginLeft: "1px" }}>
          <div>
            <input type="radio" value="2" checked={this.state.deadline === '2' ? true : false} onChange={this.handleDeadlineClick.bind(this)} /> <label> {couterpart.translate('wo_deadline_no')} </label>
          </div>
        </div>
        <div style={{ marginLeft: "1px" }}>
          <div>
            <input type="radio" value="0" checked={this.state.deadline === '0' ? true : false} onChange={this.handleDeadlineClick.bind(this)} /> <label> {couterpart.translate('wo_deadline_all')} </label>
          </div>
        </div>
      </>
    );
  }

  renderCsReview() {
    return (
      <>
        <div style={{ marginLeft: "1px" }}>
          <div>
            <input type="radio" value="2" checked={this.state.csReview === '2' ? true : false} onChange={this.handleCSReviewClick.bind(this)} /> <label> {couterpart.translate('wo_csReview_0')} </label>
          </div>
        </div>
        <div style={{ marginLeft: "1px" }}>
          <div>
            <input type="radio" value="0" checked={this.state.csReview === '0' ? true : false} onChange={this.handleCSReviewClick.bind(this)} /> <label> {couterpart.translate('wo_csReview_1')} </label>
          </div>
        </div>
        <div style={{ marginLeft: "1px" }}>
          <div>
            <input type="radio" value="1" checked={this.state.csReview === '1' ? true : false} onChange={this.handleCSReviewClick.bind(this)} /> <label> {couterpart.translate('wo_csReview_2')} </label>
          </div>
        </div>
        <div style={{ marginLeft: "1px" }}>
          <div>
            <input type="radio" value="4" checked={this.state.csReview === '4' ? true : false} onChange={this.handleCSReviewClick.bind(this)} /> <label> {couterpart.translate('wo_csReview_3')} </label>
          </div>
        </div>
      </>
    );
  }

  renderReviewButton() {
    let reviewed_button_title = couterpart.translate('button_mark');

    if (PORT_IN_USED != '443') {
      reviewed_button_title = couterpart.translate('button_mark_reviewed');
    }

    if (!AuthenticationService.isAdmin()) {
      return (<></>)
    }

    return (
      <button className="myButton"
        onClick={this.markWoReviewed.bind(this)}>
        <MdImportExport color={ICON_COLOR} />
        &nbsp;{reviewed_button_title}
      </button>
    )
  }

  renderIncidentButton() {
    if (!AuthenticationService.isAdmin()) {
      return (<></>)
    }

    return (
      <button className="myButton"
        onClick={this.resolveIncidents.bind(this)}>
        <MdImportExport color={ICON_COLOR} />
        &nbsp;{couterpart.translate('button_incident')}
      </button>
    )
  }

  renderBongButton() {
    if (!AuthenticationService.isAdmin()) {
      return (<></>)
    }

    return (
      <button className="myButton"
        onClick={this.toBong.bind(this)}>
        <MdImportExport color={ICON_COLOR} />
        &nbsp;{couterpart.translate('button_bong')}
      </button>
    )
  }

  handleSelectAllClick() {
    if (this.state.selectAll === '1') {
      this.setState({ selectAll: '0', selectedWoStatusList: [], woSubStatus: undefined });
    } else {
      let allStattus = this.state.statusList;
      this.setState({ selectAll: '1', selectedWoStatusList: allStattus, woSubStatus: undefined });
    }
  }

  onStatusSelect(selectedList, selectedItem) {
    if (selectedItem.id === 0) {
      this.handleSelectAllClick()
      return;
    }
    this.setState({
      selectedWoStatusList: selectedList
    });
  }

  onStatusRemove(selectedList, removedItem) {
    if (removedItem.id === 0) {
      this.handleSelectAllClick()
      return;
    }
    this.setState({
      selectedWoStatusList: selectedList
    });
  }

  handleIgnoreSemiClick() {
    if (this.state.ignoreSemi === '1') {
      this.setState({ semi: '0', ignoreSemi: '0' });
    } else {
      this.setState({ semi: '-1', ignoreSemi: '1' });
    }
  }

  handleSemiClick() {
    if (this.state.semi === '1') {
      this.setState({ semi: '0', ignoreSemi: '-1' });
    } else {
      this.setState({ semi: '1', ignoreSemi: '-1' });
    }
  }

  handleItemTypeClick(e) {
    let value = e.target.value;
    this.setState({ filterItemType: value });
  }

  handleKeyDown(e) {
    if (e.key === 'Enter') {
      this.onFilter()
    }
  }

  renderCountryList() {
    if (this.state.countries === undefined || this.state.countries === null) {
      return (<></>);
    }
    return (
      <select onChange={this.handleCountryChange.bind(this)}
        value={this.state.country}>
        <option value="all">{couterpart.translate('order_country_all')}</option>
        {this.state.countries.map(x => <option value={x.name} key={x.name}>{x.name}</option>)}
      </select>
    );
  }

  renderShopList() {
    if (!AuthenticationService.isAdmin()) {
      return (<></>);
    }

    let options = this.state.shops !== undefined ? this.state.shops : []
    return (
      <select className="selectBox3" value={this.state.store} onChange={this.handleShopChange.bind(this)} name="store">
        <option key="empty" value=""></option>
        {options.map(option => this.renderShopOption(option))}
      </select>
    );
  }

  loadWorkers() {
    if (AuthenticationService.isAdmin()) {
      UserDataService.retrieveWorkers().then(data => {
        let len = data.length;
        let workers = [];
        for (let i = 0; i < len; i++) {
          workers.push({ key: data[i].id, label: data[i].firstName + data[i].lastName, value: data[i].id, userName: data[i].userName })
        }
        this.setState({ workers: workers });
      });
    }
  }

  renderWorkers() {
    if ((this.state.workers === undefined)) {
      return (<></>);
    }
    return (
      <>
        <select onChange={this.handleSelectWorker.bind(this)} className="select_margin">
          <option key="" value=""></option>
          {this.state.workers !== undefined && this.state.workers.map(option => this.renderWorkerOption(option))}
        </select>&nbsp;&nbsp;
      </>
    );
  }

  handleSelectWorker(e) {
    let value = e.target[e.target.selectedIndex].value;
    this.setState({
      workerId: value,
      selectedWorkerName: e.target[e.target.selectedIndex].text
    });
  };

  renderWorkerOption(option) {
    return (
      <option key={option.key} value={option.key}>{option.userName}</option>
    );
  }

  renderShopOption(option) {
    return (
      <option key={option.name} value={option.name}>{option.name}</option>
    );
  }

  handleShopChange(e) {
    var name = e.target.name;
    var value = e.target.value;
    this.setState({ [name]: value });
  }

  gotoQualityReport() {
    var encodedStringBtoA = btoa(this.state.workOrder.workOrderNo);
    this.props.history.push("/qr?soDh=" + encodedStringBtoA);
  }

  gotoReport(workOrderNo) {
    var encodedStringBtoA = btoa(workOrderNo);
    this.props.history.push("/qr?soDh=" + encodedStringBtoA);
  }

  render() {
    if (!AuthenticationService.isAdmin() && !AuthenticationService.isService() && !AuthenticationService.isQuality()) {
      return (<div>Unauthorized access.1</div>);
    }

    return (
      <div>
        <MenuComponent2 />
        <ToastsContainer store={ToastsStore} position="bottom_center" />
        <br />
        <div className="row border-top border-left border-right border-bottom border-light-gray" style={{ margin: '2px' }}>
          <div className="col-12">
            <div className="row">
              <div className="col-4 border-top border-left border-right border-bottom border-light-gray" style={{ padding: '5px' }}>
                <div className="row">
                  <div className="col-2" style={{ whiteSpace: 'nowrap' }}>
                    <label><b>{couterpart.translate('order_date_from')}</b></label>
                  </div>
                  <div className="col-3">
                    <div className="customDatePickerWidth">
                      <DatePicker name="orderDateFrom"
                        dateFormat="MM/dd/yyyy hh:mm"
                        selected={WorkOrderUtil.convertToDate(this.state.fromDate)}
                        onChange={this.handleFromDateChange.bind(this)} />
                    </div>
                  </div>
                  <div className="col-2" style={{ whiteSpace: 'nowrap' }}><label><b>{couterpart.translate('order_date_to')}</b></label></div>
                  <div className="col-3">
                    <div className="customDatePickerWidth">
                      <DatePicker name="orderDateTo"
                        dateFormat="MM/dd/yyyy hh:mm"
                        selected={WorkOrderUtil.convertToDate(this.state.toDate)}
                        onChange={this.handleToDateChange.bind(this)} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-6 border-top border-left border-right border-bottom border-light-gray" style={{ padding: '5px' }}>
                <div className="row">
                  <div className="col-3">
                    <input type="checkbox" value="1" checked={this.state.byDeadline === '1' ? true : false} onChange={this.handleByDeadlineClick.bind(this)} /> <label> {couterpart.translate('wo_by_deadline')} </label>
                  </div>
                  <div className="col-2">
                    <label><b>{couterpart.translate('order_date_from')}</b></label>
                  </div>
                  <div className="col-2">
                    <div className="customDatePickerWidth">
                      <DatePicker name="orderDateFrom"
                        dateFormat="MM/dd/yyyy hh:mm"
                        selected={WorkOrderUtil.convertToDate(this.state.fromDeadlineDate)}
                        onChange={this.handleFromDeadlineDateChange.bind(this)} /></div>
                  </div>
                  <div className="col-2"><label><b>{couterpart.translate('order_date_to')}</b></label></div>
                  <div className="col-2">
                    <div className="customDatePickerWidth">
                      <DatePicker name="orderDateTo"
                        dateFormat="MM/dd/yyyy hh:mm"
                        selected={WorkOrderUtil.convertToDate(this.state.toDeadlineDate)}
                        onChange={this.handleToDeadlineDateChange.bind(this)} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-2 border-top border-left border-right border-bottom border-light-gray" style={{ padding: '5px' }}>
                <div className="row">
                  <div className="col-4" style={{ whiteSpace: 'nowrap' }}><label><b>{couterpart.translate('work_order_country')}</b></label></div>
                  <div className="col-8">
                    {this.renderCountryList()}
                  </div>
                </div>
              </div>
            </div>
            <div className="row ">
              <div className="col-4" style={{ padding: '5px', marginRight: '5px' }}>
                <div className="row">
                  <div className="col-12" style={{ width: "100%", marginTop: "5px" }}><label><b>{couterpart.translate('work_orders')}</b></label>
                    <div className="row">
                      <div className="col-12">
                        <Multiselect style={{ width: "100%" }}
                          options={this.state.statusList}
                          selectedValues={this.state.selectedWoStatusList}
                          onSelect={this.onStatusSelect.bind(this)}
                          onRemove={this.onStatusRemove.bind(this)}
                          displayValue="name"
                          showCheckbox={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-7" style={{ marginLeft: '5px' }}>
                <div className="row">
                  <div className="col-4 border-top border-left border-right border-bottom border-light-gray" style={{ paddingTop: '5px' }}>
                    <div className="row">
                      <div className="col-4" style={{ paddingLeft: '10px', paddingRight: '0px' }}>
                        <input type="text" defaultValue={this.state.orderNo} style={{ width: '100%' }}
                          placeholder={couterpart.translate('order_no')}
                          onChange={this.handleOrderNoChange.bind(this)} onKeyDown={(e) => { e.persist(); setTimeout(() => { this.handleOrderNoChange(e) }, 0); }} onKeyDown={this.handleKeyDown.bind(this)} />
                      </div>
                      <div className="col-4" style={{ paddingLeft: '5px', paddingRight: '0px' }}>
                        <input type="text" defaultValue={this.state.pcode} style={{ width: "100%" }}
                          placeholder={couterpart.translate('shop_pcode')}
                          onChange={this.handlePcodeChange.bind(this)} onKeyDown={(e) => { e.persist(); setTimeout(() => { this.handlePcodeChange(e) }, 0); }} onKeyDown={this.handleKeyDown.bind(this)} />
                      </div>
                      <div className="col-4" style={{ paddingLeft: '5px', paddingRight: '0px', paddingTop: '5px' }}>
                        <input type="checkbox" value={1} checked={this.state.includeMau == 1 ? true : false} onChange={this.handleIncludeMauClick.bind(this)} /> &nbsp;{couterpart.translate('work_order_mau')}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-8" style={{ paddingLeft: '10px', paddingRight: '0px' }}>
                        {this.renderItemList()}
                      </div>
                      <div className="col-4" style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                        <input type="text" size="16" className="textB" defaultValue={this.state.customer} style={{ width: "100%" }}
                          placeholder={couterpart.translate('customer_name')}
                          onChange={this.handleCustomerChange.bind(this)} onKeyDown={(e) => { e.persist(); setTimeout(() => { this.handleCustomerChange(e) }, 0); }} onKeyDown={this.handleKeyDown.bind(this)} />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12" style={{ paddingLeft: '10px', paddingRight: '0px' }}>
                        {this.renderPersonalization()}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-6" style={{ paddingLeft: '10px', paddingRight: '0px' }}>
                        <input type="checkbox" value={1} checked={this.state.includeImage == 1 ? true : false} onChange={this.handleIncludeImageClick.bind(this)} /> &nbsp;{couterpart.translate('work_order_images')}
                      </div>
                      <div className="col-6" style={{ paddingLeft: '10px', paddingRight: '0px' }}>
                        <input type="checkbox" value={1} checked={this.state.incident == 'Y' ? true : false} onChange={this.handleIncidentClick.bind(this)} /> &nbsp;{couterpart.translate('incident')}
                      </div>
                    </div>
                  </div>
                  <div className="col-2">
                    <div className="row">
                      <div className="col-12 border-top border-left border-right border-bottom border-light-gray" style={{ padding: "5px" }}>
                        {this.renderSemi()}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 border-top border-left border-right border-bottom border-light-gray" style={{ padding: "5px" }}>
                        {this.renderItemTypeFilter()}
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="row">
                      <div className="col-9">
                        <div className='row'>
                          <div className="col-7 border-top border-left border-right border-bottom border-light-gray" style={{ padding: "5px" }}>
                            {this.renderDealine()}
                          </div>
                          <div className="col-5 border-top border-left border-right border-bottom border-light-gray" style={{ padding: "5px" }}>
                            {this.renderCsReview()}
                          </div>
                        </div>
                        <div className='row'>
                          <div className="col-12 border-top border-left border-right border-bottom border-light-gray" style={{ padding: "5px" }}>
                            <input type="checkbox" value={0} checked={this.state.urgent == 1 ? true : false} onChange={this.handleUrgentClick.bind(this)} /> &nbsp;{couterpart.translate('filter_urgent')}
                          </div>
                        </div>
                      </div>
                      <div className="col-3" style={{ padding: '5px' }}>
                        <div className="row" style={{ paddingLeft: '5px' }}>
                          <div className="col-12" style={{ paddingLeft: '10px', paddingRight: '0px' }}>
                            {this.renderShopList()}
                          </div>
                        </div>
                        <div className="row" style={{ paddingLeft: '5px' }}>
                          <div className="col-12" style={{ paddingLeft: '10px', paddingRight: '0px' }}>
                            {this.renderWorkers()}
                          </div>
                        </div>
                        <div className="row" style={{ padding: '5px' }}>
                          <div className="col-12" style={{ paddingLeft: '10px', paddingRight: '0px' }}>
                            <button className="myButton2" style={{ width: "100%" }}
                              onClick={this.onFilter.bind(this)}>
                              <FaFilter color={ICON_COLOR} />
                              &nbsp;{couterpart.translate('button_filter')}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.renderProductList()}
        <Spinner size={25} spinnerColor={ICON_COLOR} spinnerWidth={2} visible={this.state.spinnerVisible} />
        <Dialog ref={(component) => { this.dialog = component }} />
        <Modal show={this.state.show} onHide={this.handleClose.bind(this)} backdrop="static" dialogClassName='modal-80w'>
          <Modal.Header closeButton style={{ background: 'lightblue' }}>
            <Modal.Title>{"Chi tiết đơn hàng"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-10">

              </div>
              <div className="col-2">
                <button className="myButton" onClick={this.gotoQualityReport.bind(this)}>
                  <TiRefresh color={ICON_COLOR} />&nbsp;
                  {couterpart.translate('quality_them_report')}</button>
              </div>

            </div>
            <div className="row">
              <div className="col-7">
                <div className="row">
                  <div className="col-4 border-top border-left border-light-gray">
                    <div className="row">
                      <img alt="" src={"data:image/gif;base64," + this.state.workOrder.qrCode} />
                    </div>
                    <div className="row">{this.state.workOrder.workOrderNo}</div>
                  </div>
                  <div className="col-1 border-top border-left border-light-gray">
                    <div className="row border-bottom border-light-gray">
                      <label className="labelBox_red">{couterpart.translate('work_order_urgent_level')}</label>
                    </div>
                    <div className="row">
                      <label style={{ color: 'red', margin: '2px' }}>{this.state.workOrder.urgent}</label>
                    </div>
                  </div>
                  <div className="col-6 border-top border-left border-light-gray  border-right">
                    <div className="row border-bottom border-light-gray">
                      <div className="col-4">
                        <label className="labelBox">{couterpart.translate('work_order_order_date_s')}</label>
                      </div>
                      <div className="col-8 border-left border-light-gray">
                        <label className="labelValueBox">
                          {WorkOrderUtil.formatShortDisplayDateMMddyyyy(this.state.workOrder.orderDate)}
                        </label>
                      </div>
                    </div>
                    <div className="row border-bottom border-light-gray">
                      <div className="col-4">
                        <label className="labelBox">
                          {couterpart.translate('work_order_web_dealine')}
                        </label>
                      </div>
                      <div className="col-8 border-left border-light-gray">
                        <label className="labelValueBox">
                          {WorkOrderUtil.formatShortDisplayDateMMddyyyy2_1(this.state.workOrder.prodDeadlineWeb)}
                        </label>
                      </div>
                    </div>
                    <div className="row border-light-gray border-bottom">
                      <div className="col-4">
                        <label className="labelBox">{couterpart.translate('work_order_prod_dealine')}</label>
                      </div>
                      <div className="col-8 border-left border-light-gray">
                        <label className="labelValueBox">
                          {WorkOrderUtil.formatShortDisplayDateMMddyyyy2_1(this.state.workOrder.prodDeadlineTs)}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-1 border-top border-left border-light-gray">
                    <label className="labelBox">{couterpart.translate('work_order_code')}</label>
                  </div>
                  <div className="col-2 border-top border-left border-light-gray">
                    <label>{this.state.workOrder.sku}</label>
                  </div>
                  <div className="col-2 border-top border-left border-light-gray">
                    <label className="labelBox">{couterpart.translate('shop_pcode')}</label>
                  </div>
                  <div className="col-3 border-top border-left border-light-gray">
                    <label className="labelValueBox">{this.state.workOrder.fullPCode}</label>
                  </div>
                  <div className="col-1 border-top border-left border-light-gray">
                    <label className="labelBox">{couterpart.translate('work_order_font')}</label>
                  </div>
                  <div className="col-2 border-top border-left border-right border-light-gray">
                    {this.renderFontList()}
                  </div>
                </div>
                <div className="row">
                  <div className="col-1 border-top border-left border-light-gray">
                    <label className="labelBox">{couterpart.translate('work_order_color')}</label>
                  </div>
                  <div className="col-2 border-top border-left border-light-gray">
                    {this.renderColorList()}
                  </div>
                  <div className="col-1 border-top border-left border-light-gray">
                    <label className="labelBox">{couterpart.translate('work_order_type')}</label>
                  </div>
                  <div className="col-3 border-top border-left border-light-gray">
                    {this.renderTypeList()}
                  </div>
                  <div className="col-2 border-top border-left border-light-gray">
                    <label className="labelBox_red">{couterpart.translate('work_order_urgent_by_cust')}</label>
                  </div>
                  <div className="col-2 border-top border-left border-right border-light-gray">
                    <label className="labelBox_red">{this.state.workOrder.isUrgentByCustomer}</label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-1 border-top border-left border-light-gray">
                    <label className="labelBox_red">{couterpart.translate('work_order_quantity_s')}</label>
                  </div>
                  <div className="col-2 border-top border-left border-light-gray">
                    <label> {this.state.workOrder.qty} </label>
                  </div>
                  <div className="col-1 border-top border-left border-light-gray">
                    <label className="labelBox">{couterpart.translate('work_order_size')}</label>
                  </div>
                  <div className="col-3 border-top border-left border-light-gray">
                    <label> {this.state.workOrder.lengthSize} </label>
                  </div>
                  <div className="col-2 border-top border-left border-light-gray">
                    <label className="labelBox">{couterpart.translate('work_order_shipto')}</label>
                  </div>
                  <div className="col-2 border-top border-left border-right border-light-gray">
                    <label> {this.state.workOrder.shipTo} </label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-1 border-top border-left border-light-gray">
                    <label className="labelBox">{couterpart.translate('work_order_customer_s')}</label>
                  </div>
                  <div className="col-4 border-top border-left border-light-gray">
                    <label className="labelValueBox">{this.state.workOrder.customer}</label>
                  </div>
                  <div className="col-2 border-top border-left border-light-gray">
                    <label className="labelBox">{couterpart.translate('work_order_urgent')}</label>
                  </div>
                  <div className="col-4 border-top border-left border-right border-light-gray">
                    <label> {this.state.workOrder.carrierServiceRequested} </label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-1 border-top border-left border-light-gray">
                    <label className="labelBox">{couterpart.translate('work_order_design_level')}</label>
                  </div>
                  <div className="col-2 border-top border-left border-right border-light-gray">
                    <label> {this.state.workOrder.type} </label>
                  </div>
                  <div className="col-2 border-top border-left border-light-gray">
                    <label className="labelBox">{couterpart.translate('work_order_designer')}</label>
                  </div>
                  <div className="col-2 border-top border-left border-light-gray">
                    <label>{this.state.workOrder.designer}</label>
                  </div>
                  <div className="col-2 border-top border-left border-light-gray">
                    <label className="labelBox">{couterpart.translate('work_ngay_nhap_lieu')}</label>
                  </div>
                  <div className="col-2 border-top border-left border-right border-light-gray">
                    <label className="labelValueBox">{
                      WorkOrderUtil.formatShortDisplayDateMMddyyyy2(this.state.workOrder.ngayNhapLieu)
                    }</label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-2 border-top border-left border-light-gray">
                    <label className="labelBox">
                      {couterpart.translate('work_order_personalization')}
                    </label>
                  </div>
                  <div className="col-9 border-top border-left border-right border-light-gray">
                    <textarea name="name" className="form-control textArea" id="name"
                      placeholder="Personalization"
                      value={this.state.workOrder.personalization === null ? '' : this.state.workOrder.personalization}
                      onChange={this.handlePersonalizationChange.bind(this)} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-2 border-top border-left border-light-gray">
                    <label className="labelBox">{couterpart.translate('work_order_special_note')}</label>
                  </div>
                  <div className="col-9 border-top border-left border-right border-light-gray">
                    <label>{this.state.workOrder.notesInternal ? this.state.workOrder.notesInternal : ''}</label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-2 border-top border-left border-light-gray">
                    <label className="labelBox">{couterpart.translate('work_order_ycdb_shipping')}</label>
                  </div>
                  <div className="col-9 border-top border-left border-right border-light-gray">
                    <label>{this.state.workOrder.ycdbShipping ? this.state.workOrder.ycdbShipping : ''}</label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-2 border-top border-left border-light-gray">
                    <label className="labelBox">
                      {couterpart.translate('label_note')}
                    </label>
                  </div>
                  <div className="col-9 border-top border-left border-right border-light-gray">
                    <label>{this.state.workOrder.notesFromService ? this.state.workOrder.notesFromService : ''}</label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-2 border-top border-left border-light-gray">
                    <label className="labelBox">
                      {couterpart.translate('work_order_status')}
                    </label>
                  </div>
                  <div className="col-6 border-top border-left border-light-gray">
                    <div className="row">
                      <div className="col-12 border-light-gray">
                        <label>{this.state.workOrder.status}</label>
                      </div>
                    </div>
                  </div>
                  <div className="col-3 border-top border-left border-right border-light-gray">
                    <div className="row">
                      <label className="labelBox">
                        {couterpart.translate('work_order_tthk')}
                      </label>
                    </div>
                    <div className="row">
                      <label>{this.state.workOrder.csReview}</label>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-2 border-top border-left border-bottom border-light-gray">
                    <label className="labelBox">{couterpart.translate('work_order_itype')}</label>
                  </div>
                  <div className="col-9 border-top border-left border-right border-bottom border-light-gray">
                    {WorkOrderUtil.getItemTypeDescription(this.state.workOrder.itemType)}
                  </div>
                </div>
                <div className="row" style={{ marginTop: "10px" }}>
                  <div className="col-11 border-top border-left border-right border-bottom border-light-gray">
                    <label htmlFor="">Hinh Khach: {this.state.workOrder.imageURL}</label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-11 border-top border-left border-right border-bottom border-light-gray">
                    <WorkOrderAdditions mode="MODE_EDIT"
                      caption={couterpart.translate('work_order_additions')}
                      workOrderId={this.state.workOrderId}
                      isUpdated={this.state.updated} />
                  </div>
                </div>
              </div>
              <div className="col-5">
                <div className="row">
                  <WorkOrderImages mode="MODE_EDIT" largeMode={1}
                    workOrderId={this.state.workOrderId}
                    isUpdated={this.state.updated} />
                </div>
                <div className="row">&nbsp;</div>
                <div className="row">
                  <ItemDetailsViewById itemSku={this.state.workOrder.sku} />
                </div>
              </div>
            </div>
            <div className="row">&nbsp;</div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={this.handleClose.bind(this)}>Cancel</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}
export default withRouter(QualityProductList);